import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-patient-record',
  templateUrl: './view-patient-record.component.html',
  styleUrls: ['./view-patient-record.component.css']
})
export class ViewPatientRecordComponent implements OnInit {

  recordSource:any;

  constructor(public dialogRef: MatDialogRef<ViewPatientRecordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {recordSource: string }, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    console.log(this.data.recordSource);
    this.recordSource= this.data.recordSource
  }
  close() {
    this.dialogRef.close();
  }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
